import _extends from "@babel/runtime/helpers/extends";
import classNames from "classnames/dedupe";
import PropTypes from "prop-types";
import React from "react";
import { Text } from "./text";
export const Blockquote = /*#__PURE__*/React.forwardRef(
/**
 *
 * @param {object} props
 * @param {any} [props.as]
 * @param {any} props.children
 * @param {any} [props.className]
 * @param {*} ref
 * @returns {JSX.Element}
 */
function Blockquote({
  as,
  children,
  className,
  ...props
}, ref) {
  const blockquoteClass = classNames("blockquote", className);
  return /*#__PURE__*/React.createElement(Text, _extends({
    as: as || "blockquote",
    className: blockquoteClass,
    ref: ref
  }, props), children);
});
Blockquote.propTypes = {
  as: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.elementType]),
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};
export default Blockquote;